module.exports = __webpack_public_path__ + "img/JustWatch_logo.145e4e01.png";